import { LabelAssociationSchema as StoredLabelAssociationSchema, LabelIdSchema, LabelSchema } from "@storytell/types";
import z from "zod";

export const LabelIdParamsSchema = z.object({
  id: z.string(),
});

export const CreateLabelInputSchema = LabelSchema.pick({
  name: true,
  description: true,
  icon: true,
  color: true,
});

export const UpdateLabelInputSchema = LabelSchema.pick({
  name: true,
  description: true,
  icon: true,
  color: true,
});

// Sync endpoint returns a map of label IDs to label objects
export const LabelsSyncSchema = z.object({
  labels: z.record(LabelIdSchema, LabelSchema),
});

// Label association schemas
export const AssociateLabelInputSchema = z.object({
  labelId: z.string(),
  resourceId: z.string(),
  resourceType: z.string(),
});
export type AssociateLabelInput = z.infer<typeof AssociateLabelInputSchema>;

export const DisassociateLabelInputSchema = z.object({
  associationId: z.string(),
});
export type DisassociateLabelInput = z.infer<typeof DisassociateLabelInputSchema>;

const LabelAssociationSchema = z.object({
  id: z.string(),
  labelId: z.string(),
  resourceId: z.string(),
  resourceType: z.string(),
  tenantId: z.string(),
  createdBy: z.string(),
  createdAt: z.string(),
  modifiedBy: z.string(),
  modifiedAt: z.string(),
});

export const AssociateLabelResponseSchema = z.array(LabelAssociationSchema);

// Bulk operation schemas (arrays of the above)
export const BulkAssociateLabelInputSchema = z.array(AssociateLabelInputSchema);

export const BulkDisassociateLabelInputSchema = z.array(DisassociateLabelInputSchema);

export const LabelAssociationsSyncSchema = z.array(LabelAssociationSchema);

export const ResourceLabelAssociationsParamsSchema = z.object({
  resourceType: z.string(),
  resourceId: z.string(),
});

export const ResourceLabelAssociationsSchema = z
  .array(StoredLabelAssociationSchema)
  .nullable()
  .transform((associations) => associations ?? []);
